import { useEffect, useState } from "react";
import api from "@/lib/api";
import { IMG } from "@/lib/brand";
import { Section, PageHeader } from "@/components/common";

export default function ProjetsCulturels() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/cultural").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="cultural-page">
      <PageHeader eyebrow="Projets culturels" title="Transmettre & partager" subtitle="Ateliers, transmission, actions culturelles, événements et projets territoriaux." image={IMG.live} />
      <Section className="py-20">
        {items.length === 0 ? (
          <div className="card-dark p-10 text-center text-slate-500 text-sm"><span className="font-mono text-xs uppercase tracking-widest text-amber-300">À compléter</span><p className="mt-3">Les projets culturels seront présentés ici depuis l'administration.</p></div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((c) => (
              <div key={c.id} className="card-dark overflow-hidden">
                <div className="aspect-video overflow-hidden bg-[#1A1A20]">{c.image && <img src={c.image} alt={c.title} className="w-full h-full object-cover" />}</div>
                <div className="p-6">
                  {c.type && <span className="eyebrow">{c.type}</span>}
                  <h3 className="font-display font-bold text-lg mt-2">{c.title}</h3>
                  {c.description && <p className="text-sm text-slate-400 mt-2">{c.description}</p>}
                </div>
              </div>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}
